import { render, staticRenderFns } from "./CancellationsList.vue?vue&type=template&id=5f3bef39"
import script from "./CancellationsList.vue?vue&type=script&lang=js"
export * from "./CancellationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports